import React from "react";

import {
  Alert,
  LoadingIndicator,
  SettingsPageContainer,
  useToast,
} from "../../../components";
import {
  FeatureName,
  useOrgMsftTeamsSettingsQuery,
  useUpdateOrganizationTeamsNotetakerMutation,
} from "../../graphql";
import { useHasFeatureAccess } from "../../hooks/useHasFeatureAccess";
import MsftTeamsSettingsForm from "./MsftTeamsSettingsForm";

const MsftTeamsSettings: React.FC = () => {
  const toast = useToast();

  const settingsQuery = useOrgMsftTeamsSettingsQuery();
  const orgTeamsSettings = settingsQuery.data?.currentUser?.organization;

  const [updateTeamsNotetakerSettings, { loading: mutationLoading }] =
    useUpdateOrganizationTeamsNotetakerMutation();

  const hasVirtualOnsiteAccess = useHasFeatureAccess(
    FeatureName.VirtualOnsiteSplitting
  );

  if (!orgTeamsSettings) {
    return (
      <SettingsPageContainer heading="Microsoft Teams notetaker">
        {settingsQuery.loading && <LoadingIndicator mt="25%" />}
        {settingsQuery.error && (
          <Alert
            mb={8}
            status="error"
            description={settingsQuery.error.message}
          />
        )}
      </SettingsPageContainer>
    );
  }

  return (
    <SettingsPageContainer heading="Microsoft Teams notetaker">
      <MsftTeamsSettingsForm
        organizationName={orgTeamsSettings.name}
        teamsNotetakerEnabled={orgTeamsSettings.teamsNotetakerEnabled}
        teamsSendCancelRecordingChatMessage={
          orgTeamsSettings.teamsSendCancelRecordingChatMessage
        }
        teamsNotetakerDisclaimer={orgTeamsSettings.teamsNotetakerDisclaimer}
        teamsNotetakerDisclaimerType={
          orgTeamsSettings.teamsNotetakerDisclaimerType
        }
        teamsNotetakerDisplayImageBucketPath={
          orgTeamsSettings.teamsNotetakerDisplayImageBucketPath
        }
        defaultDisclaimer={orgTeamsSettings.notetakerRecorderDisclaimerDefault}
        defaultDisplayName={orgTeamsSettings.teamsNotetakerDisplayName}
        showVirtualOnsiteSetting={hasVirtualOnsiteAccess}
        virtualOnsiteEnabled={orgTeamsSettings.virtualOnsiteEnabledMsTeams}
        isLoading={settingsQuery.loading || mutationLoading}
        error={settingsQuery.error ?? undefined}
        onSubmit={(formData) => {
          return updateTeamsNotetakerSettings({ variables: formData })
            .then((result) => {
              if (result.data?.updateOrganizationTeamsNotetaker?.organization) {
                toast({
                  status: "success",
                  title: "Microsoft Teams Notetaker Settings",
                  description: "Saved!",
                });
              }
            })
            .catch((error) => {
              toast({
                status: "error",
                title: "Microsoft Teams Notetaker Settings",
                description:
                  error?.message ?? "There was a problem - please try again",
              });
            });
        }}
      />
    </SettingsPageContainer>
  );
};

export default MsftTeamsSettings;
